/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FCMTokenRequest = {
    properties: {
        token: {
    type: 'string',
    isRequired: true,
},
    },
};